/// <amd-module name="Search/WorkItem/Components/Notification" />
import * as Resources from "Search/Shared/Resources";
import { IndexingBanner } from "Search/WorkItem/Flux/Stores/NotificationStore";
import { OrgSearchUrlLoadState } from "Search/Shared/Base/Stores/OrganizationInfoStore"
import { IAggregatedState } from "Search/WorkItem/Flux/StoresHub";
import { ActionCreator } from "Search/WorkItem/Flux/ActionCreator";
import { ObservableValue } from "VSS/Core/Observable";
import { INotificationProps } from "Search/Shared/Components/NotificationArea";
import { MessageBarSeverity } from "VSSUI/MessageBar";

export function handlePivotNotification(
    pageNotification: ObservableValue<INotificationProps>,
    getAggregatedState: () => IAggregatedState,
    actionCreator: ActionCreator) {
    const { notificationStoreState, organizationInfoState } = getAggregatedState();
    const { indexingBannerState } = notificationStoreState;
    const { publishNotificationBanner, errorNotificationBannerDismissed } = actionCreator;
    const isOrgSearchUrlLoadFailed = organizationInfoState.orgSearchUrlLoadState === OrgSearchUrlLoadState.OrgSearchUrlLoadFailed;

    let message;
    let linkLabel;
    let onLinkClick;
    let onDismiss;
    let severity = MessageBarSeverity.Warning;
    let isFormatted = false;

    if (isOrgSearchUrlLoadFailed) {
        message = Resources.FailedLoadingOrgURLMessage;
        isFormatted = true;
        linkLabel = Resources.RefreshText;
        // @ts-ignore TypeScript 4.4 upgrade
        onLinkClick = () => window.location.reload(true);
        onDismiss = errorNotificationBannerDismissed;
        severity = MessageBarSeverity.Error;
    } else if (indexingBannerState === IndexingBanner.AccountIndexing) {
        message = Resources.AccountIsGettingIndexedBannerMessage;
    }

    if (message) {
        // Handle indexing scenarios
        pageNotification.value = {
            visible: true,
            isFormatted,
            severity,
            message,
            onLinkClick,
            linkLabel,
            onDismiss
        }

        publishNotificationBanner(isOrgSearchUrlLoadFailed
            ? OrgSearchUrlLoadState[organizationInfoState.orgSearchUrlLoadState]
            : IndexingBanner[notificationStoreState.indexingBannerState]);
    } else {
        // dispose notification if none of indexing is in progress, or partial results are obtained.
        pageNotification.value = {
            ...pageNotification.value,
            visible: false
        }
    }
}
